import { Controller } from "@hotwired/stimulus";
import axios from "axios";

export default class extends Controller {
  static targets = ["input", "suggestions", "display", "textdisplay"];
  static values = { endpoint: String };

  connect() {
    this.debounceTimer = null;
  }

  preventSubmit(e) {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  }

  onInput(e) {
    clearTimeout(this.debounceTimer);
    const query = e.target.value.trim();
    if (query.length < 3) {
      this.suggestionsTarget.classList.add("hidden");
      return;
    }
    this.debounceTimer = setTimeout(() => {
      this.fetchSuggestions(query);
    }, 300);
  }

  async fetchSuggestions(query) {
    try {
      const { data } = await axios.get(
        `${this.endpointValue}?q=${encodeURIComponent(query)}`,
      );
      this.displaySuggestions(data);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      this.suggestionsTarget.classList.add("hidden");
    }
  }

  displaySuggestions(places) {
    if (!places || places.length === 0) {
      this.suggestionsTarget.classList.add("hidden");
      return;
    }
    this.suggestionsTarget.innerHTML = places
      .map(
        (place) => `
      <div class="p-2 hover:bg-gray-100 cursor-pointer"
           data-action="click->${this.identifier}#selectPlace"
           data-place='${JSON.stringify(place)}'>
        ${place.description}
      </div>
    `,
      )
      .join("");
    this.suggestionsTarget.classList.remove("hidden");
  }

  async selectPlace(e) {
    const place = JSON.parse(e.currentTarget.dataset.place);
    try {
      const { data } = await axios.post(this.endpointValue, {
        place_id: place.place_id,
      });

      this.inputTarget.value = data.id;
      this.inputTarget.setAttribute("value", data.id);
      this.textdisplayTarget.innerText =
        data[this.element.dataset.labelFieldName || "label"];
      this.displayTarget.classList.remove("hidden");
      this.suggestionsTarget.classList.add("hidden");
      this.dispatch("placeSelected", { detail: data });
    } catch (error) {
      console.error("Error fetching place details:", error);
    }

    this.suggestionsTarget.classList.add("hidden");
  }

  // Hide suggestions when clicking outside
  clickOutside(e) {
    if (!this.element.contains(e.target)) {
      this.suggestionsTarget.classList.add("hidden");
    }
  }

  clear(e) {
    e.preventDefault();
    this.displayTarget.classList.add("hidden");
    this.inputTarget.value = "";
    this.inputTarget.setAttribute("value", "");
    this.inputTarget.focus();
  }
}
